import type { FeatureFlags } from '@virtuslab/nfs-shared/src/config/featureFlags';
import type { Nullable } from '@virtuslab/nfs-shared/src/services/object';

import type { Contract } from '../services/hooks/useContract';

const baseFeatureFlags: FeatureFlags = {
  allowReportingBreak: false,
  allowAdminOnlyAbsences: false,
  allowChangingInvoiceStatus: false,
  allowChangingAdditionalCostStatus: false,
  allowChangingWorkTransferStatus: false,
  allowEditingApprovedWorkTransferProtocols: false,
  enforceInvoiceValidation: true,
  ignoreWorkTagLimits: false,
  useACL: true,
  clearCachePeriodically: false,
  ignoreLeaveLimits: false,
  showAdditionalCosts: true,
  allowRequestingAdditionalCosts: false,
};

export const getFeatureFlags = (selectedContract?: Nullable<Contract>): FeatureFlags => ({
  ...baseFeatureFlags,
  allowRequestingAdditionalCosts: selectedContract?.promisor.name.toLowerCase().includes('softwaremill') ?? false,
});

export const featureFlags: FeatureFlags = getFeatureFlags();
